<template>
	<section v-if="photos" data-component="club-gallery" data-section-intersect="dark" :data-anchor="$t('spaces', 'Espaços')">
		<div class="left-col">
			<Slideshow ref="slideshowRef" :slideshow="slideshow" class="slideshow" hydrate-on-idle />

			<PhotosBtn :url="btnUrl" class="btn" @click="handleClick" />
		</div>
		<div class="center-col">
			<Ribbon v-bind="ribbon" hydrate-on-idle />
		</div>
		<div class="right-col">
			<Photos :photos="photosSlice" hydrate-on-idle />
		</div>
	</section>
</template>

<script setup>
import Slideshow from './components/Slideshow.vue'
import Ribbon from './components/Ribbon.vue'
import Photos from './components/Photos.vue'
import { PhotosBtn } from '~/components/primitives'

import { useStringTranslation, useLocale } from '@/i18n'

const props = defineProps({
	ribbon: { type: [Boolean, Object], default: false },
	slideshow: { type: [Boolean, Array], default: false },
	photos: { type: [Boolean, Array], default: false },
})

const slideshowRef = ref(null)
const $t = useStringTranslation()
const locale = useLocale()

const btnUrl = computed(() => `/svg/circle-photos-${locale.value}.svg`)
const photosSlice = computed(() => props.photos.slice(0, 5))

const handleClick = () => {
	slideshowRef.value?.handleOpen()
}
</script>

<style lang="scss" scoped>
[data-component='club-gallery'] {
	position: relative;

	display: flex;
	width: 100%;
	height: 100vh;

	background-color: var(--color-darkBrown);

	@include max-screen($small) {
		flex-direction: column;
	}

	.left-col {
		display: grid;
		align-items: center;
		justify-items: center;

		flex: 0 0 calc(50% + var(--grid-gutter));

		cursor: pointer;

		.slideshow,
		.btn {
			grid-row: 1;
			grid-column: 1;
		}
	}

	.center-col {
		writing-mode: vertical-rl;

		@include max-screen($small) {
			writing-mode: initial;
		}
	}

	.right-col {
		flex: 1;

		@include max-screen($small) {
			height: rs(320, 220);
			flex: 0 0 rs(420, 220);
		}
	}
}
</style>
